var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-box"},[_c('div',{staticClass:"title-box flex-c-b"},[_vm._t("title")],2),_c('div',{staticClass:"item-content-box clearfix"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }